import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { NumberText } from '../NumberText/NumberText';
import { ValueOrDash } from '../ValueOrDash/ValueOrDash';

import './GridScreenTotalCell.css';

export interface GridScreenTotalCellProps {
    isNameCell: boolean;
    fractionalPartLength: number;
    title?: string;
}

const BLOCK = 'grid-screen-total-cell';

export class GridScreenTotalCell extends React.PureComponent<GridScreenTotalCellProps> {
    render() {
        const { title, isNameCell } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: { left: isNameCell }
                })}
            >
                {isNameCell ? title : this.getTotalStat()}
            </div>
        );
    }

    private getTotalStat() {
        const { title, fractionalPartLength } = this.props;

        return (
            <div className={Bem.cls(BLOCK, 'title')}>
                <ValueOrDash value={title}>
                    {title && <NumberText num={Number(title)} fractionalPartLength={fractionalPartLength} />}
                </ValueOrDash>
            </div>
        );
    }
}
